<script setup lang="ts">
</script>

<template>
  <div class="absolute top-2 right-2 flex gap-2 flex-wrap justify-end ml-7">
    <slot></slot>
  </div>
</template>
